import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../../config/withDirection';

const StyleWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    padding-right: 14px;

    dl {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: 0;
        padding: 0;
        text-align: center;
    }
    dt, dd { margin: 0; font-family: 'Roboto'; }
    dt {
        margin-bottom: 13px;
        font-size: 14px;
        color: rgba(147, 147, 147, 1);
        text-align: center;
    }
    dd {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        font-weight: 300;
        color: rgba(64, 55, 57, 1);
        letter-spacing: 0.02em;
    }

    .cost {
        padding-right: 14px;
        
        dd { display: flex; align-items: center; }
        img { margin-left: 21px; width: 12px; height: 18px; }
        // img.arrow-up { margin-bottom: 14px;}
    }

    .rate {
        div {
            display: inline-block;
            margin-left: 11px;
            border: 2px solid rgba(207, 201, 222, 1);
            height: 21px;
            width: 21px;
            border-radius: 21px;
        }
    }

    &.breakdown {
        justify-content: space-between;
        width: 275px;
        
        dt { font-size: 12px; }
        dd { font-size: 21px; }

        //.rate { text-align: right; }
    }

    @media screen and (max-width: 767px) {
        width: 100%;
        padding: 0;

        &.breakdown {
            justify-content: center;
            margin-bottom: 14px;
            width: 100%;
            padding-right: 7px;
        }
    }

    @media screen and (max-width: 480px) {
        flex-grow: 1;
        justify-content: center;

        dl:not(:only-child) {
            margin-bottom: 14px;
            width: 50%;

            dt { font-size: 12px; }
            dd {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 16px;
            }
        }

        .cost { padding-right: 7px; }
    }
`;

export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/CampaignList/CampaignDashboard/Wrapper.js